<template>
	<div class="InputText">
		<div v-if="showErrorIcon" class="dangerIcon">
			<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M11.0007 1.83301C6.02446 1.83301 1.83398 6.02348 1.83398 10.9997C1.83398 15.9759 6.02446 20.1663 11.0007 20.1663C15.9768 20.1663 20.1673 16.1068 20.1673 10.9997C20.1673 5.89253 16.1078 1.83301 11.0007 1.83301Z"
					fill="#FF0E3E"
				/>
				<ellipse cx="11.0009" cy="15.0742" rx="1.01852" ry="1.01852" fill="white" />
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M11.0007 7.02734C11.5069 7.02734 11.9173 7.43775 11.9173 7.94401L11.9173 12.0181C11.9173 12.5243 11.5069 12.9348 11.0007 12.9348C10.4944 12.9348 10.084 12.5243 10.084 12.0181L10.084 7.94401C10.084 7.43775 10.4944 7.02734 11.0007 7.02734Z"
					fill="white"
				/>
			</svg>
		</div>
		<input
			class="c_input"
			:class="transparent && 'transparent'"
			type="text"
			:value="modelValue"
			v-bind="attrs"
			:disabled="disabled"
			@input="(event) => emit('update:modelValue', (event.target as HTMLInputElement).value)"
		/>
	</div>
</template>

<script setup lang="ts">
// core
import { useAttrs } from 'vue';
defineProps<{
	modelValue?: string;
	showErrorIcon?: string;
	transparent?: boolean;
	disabled?: boolean; // 애플 회원가입 시 이름 정보 받아와 fix, disabled하기 위한 함수
}>();
const emit = defineEmits(['update:modelValue']);
const attrs = useAttrs();
</script>

<style scoped lang="scss">
.InputText {
	position: relative;
	width: 100%;
	input {
		height: 4.8rem;
		padding: 0 1rem 0rem 1rem;
		appearance: textfield;
	}
	.transparent {
		background-color: transparent;
	}
	.dangerIcon {
		position: absolute;
		top: 50%;
		left: 1rem;
		transform: translate(0, -50%);
		display: flex;
		align-items: center;
		height: 100%;
		aspect-ratio: 1;
		user-select: none;
		svg {
			width: 45%;
			height: 45%;
		}
	}
}
.error {
	input {
		padding: 0 1rem 0rem 3.6rem;
		border-color: var(--color-danger);
		box-shadow: none;
	}
}
</style>
